import { render, staticRenderFns } from "./application-create-objects-item.vue?vue&type=template&id=68bfb45d&scoped=true&"
import script from "./application-create-objects-item.vue?vue&type=script&lang=js&"
export * from "./application-create-objects-item.vue?vue&type=script&lang=js&"
import style0 from "./application-create-objects-item.vue?vue&type=style&index=0&id=68bfb45d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68bfb45d",
  null
  
)

export default component.exports